import {
    ActivatedRouteSnapshot,
    BaseRouteReuseStrategy,
} from '@angular/router';

export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
    shouldReuseRoute(
        future: ActivatedRouteSnapshot,
        curr: ActivatedRouteSnapshot
    ): boolean {
        return future.data['reload']
            ? false
            : super.shouldReuseRoute(future, curr);
    }
}
